module.exports = __webpack_public_path__ + "img/ahorcadoNuevo2.1b4249ec.png";